import { render } from "./EmailPreferences.vue?vue&type=template&id=49e8c98f&scoped=true"
import script from "./EmailPreferences.vue?vue&type=script&lang=js"
export * from "./EmailPreferences.vue?vue&type=script&lang=js"

import "./EmailPreferences.vue?vue&type=style&index=0&id=49e8c98f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e8c98f"]])

export default __exports__